import RequestUpdateFlow from 'modules/contracts/components/RequestUpdateFlow'
import UpdateFlow from 'modules/contracts/components/UpdateFlow'
import { useHasToRequestUpdate } from 'modules/contracts/hooks/useHasToRequestUpdate'
import Loading from 'modules/layout/components/Page/Loading'

const RequestOrUpdate = () => {
  const { loading, hasToRequestUpdate } = useHasToRequestUpdate()

  if (loading) {
    return <Loading />
  }

  if (hasToRequestUpdate) {
    return <RequestUpdateFlow />
  }

  return <UpdateFlow />
}

export default RequestOrUpdate
